import { createApi } from "@reduxjs/toolkit/query/react";
import { localStorageKeys } from "../../utils/localStorageItems";
import { BlankTemplatePayload } from "../types/BulkUpload";
import { ReportProcessResponse } from "../types/Scheduler";
import {
  appBaseQuery,
  baseQueryWithAuthHandling,
  preparedAuthHeader,
} from "../utils/utils";
import { API_METHODS } from "./constants";
import { API_ENDPOINTS, API_SERVER_URL } from "./endpoints";

// Fetch request to download report
export const downloadTemplate = (
  params: BlankTemplatePayload,
  type: string,
  onSuccess?: () => void,
  onError?: () => void
) => {
  const additionalHeader: HeadersInit = {};
  additionalHeader["Content-Type"] = "text/csv";

  fetch(
    `${API_SERVER_URL}${API_ENDPOINTS.BULK_UPLOAD.BLANK_TEMPLATE}?${new URLSearchParams(params as any).toString()}`,
    {
      method: API_METHODS.GET,
      headers: {
        Authorization: preparedAuthHeader(
          localStorage.getItem(localStorageKeys.accessToken)
        ),
        ...additionalHeader,
      },
    }
  )
    .then((resp) => {
      return resp.blob();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // the filename you want
      a.download = params?.with_data
        ? `${type}_${new Date().getTime().toString()}.csv`
        : `${type}_Blank_Template_${new Date().getTime().toString()}.csv`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      onSuccess && onSuccess();
    })
    .catch(() => {
      onError && onError();
    });
};

export enum SchedulerApiTags {}

export const SchedulerAPIs = createApi({
  reducerPath: "schedulerApi",
  tagTypes: [
    // SchedulerApiTags
  ],
  baseQuery: (args, api, extraOptions) =>
    baseQueryWithAuthHandling(appBaseQuery.withAuth, args, api, extraOptions),
  endpoints: (builder) => ({
    // Get process status
    getReportProcessStatus: builder.query<ReportProcessResponse, number>({
      query: (id: number) => {
        return {
          url: API_ENDPOINTS.SCHEDULER.PROCESS_STATUS(id),
          method: API_METHODS.GET,
        };
      },
      transformErrorResponse(baseQueryReturnValue) {
        // handleAuthErrorCode(baseQueryReturnValue);
        return baseQueryReturnValue;
      },
      transformResponse: (response: ReportProcessResponse) => {
        return response;
      },
    }),
  }),
});

export const { useGetReportProcessStatusQuery } = SchedulerAPIs;
